var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dashboard',{attrs:{"range-id":_vm.resId,"range-type":"cloudregions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }